import React from "react";
import { useNavigate } from "react-router-dom";
import SchoolHub from "@/components/school/SchoolHub";
import { schoolApi } from "@/lib/school";

// The platform-wide School page (the same one every HikmahVerses app shows school principals and teachers).
export default function SchoolPage() {
  const navigate = useNavigate();
  return (
    <div data-testid="school-page">
      <SchoolHub api={schoolApi} onBack={() => navigate("/dashboard")} onlyApp="stories" />
    </div>
  );
}
